import React from 'react'
import { Navigate } from 'react-router-dom'
//redux stuff
import { STORIES } from './routeConstant'

interface IMyRouteProps {
  component: any
  rest?: any
}
const GuestRoute: React.FC<IMyRouteProps> = ({ component: Component, ...rest }) => {
  const authToken = localStorage.getItem('authToken')
  return authToken ? <Navigate to={STORIES} /> : <Component {...rest} />
}

export default GuestRoute
